import * as React from 'react';
import { Component, deps, inject, observer } from '../../lib/component';
import { classes, style } from 'typestyle';
import { important, percent, px } from 'csx';
import { SVGIcon } from '../svg-icon';
import { colorBackground, colorBrand, colorContrast, colorSlate, colorSubtle, colorWhite } from '../../theme/color';
import { mediaTablet, mediaMobileOnly } from '../../theme/media';
import { transitionQuickEase } from '../../theme/transition';
import { fontHeading } from '../../theme/font';
import { resetAnchorStyles } from '../../theme/reset';
import { horizontal, wrap } from 'csstips';

export interface AccountMenuProps {
  model?: any;
}

@inject(deps)
@observer
export class AccountMenu extends Component<AccountMenuProps> {
  render() {
    const { pathname } = this.props.model.router.location;

    return (
      <div className={AccountMenu.styles.container}>
        <ul className={AccountMenu.styles.list}>
          {AccountMenu.data.links.map(({ to, label }) => (
            <li key={to} className={AccountMenu.styles.item}>
              <a
                onClick={(e) => this.handleClickLink(e, label)}
                href={to}
                className={classes(AccountMenu.styles.link, this.mapActive(to, AccountMenu.styles.linkActive))}
              >
                {label}
              </a>
            </li>
          ))}
        </ul>
        <select className={AccountMenu.styles.select} value={pathname} onChange={this.navigate}>
          {AccountMenu.data.links.map(({ to, label }) => (
            <option key={to} value={to} className={AccountMenu.styles.item}>
              {label}
            </option>
          ))}
        </select>
        <SVGIcon.ArrowRight className={AccountMenu.styles.arrow} color={colorWhite.toString()} size={10} />
      </div>
    );
  }

  mapActive = (path: string, value: any) => {
    if (this.props.model.router.location.pathname !== path) return;
    return value;
  };

  navigate = (event: React.FormEvent<any>) => {
    this.props.model.router.push((event.target as HTMLSelectElement).value);
  };

  handleClickLink = (event: React.MouseEvent<any>, label: string) => {
    event.preventDefault();
    this.props.model.router.push((event.target as HTMLAnchorElement).href);
    this.props.controller.analytics.sendMixpanel(`My Account > User clicks ${label}`);
  };

  static data = {
    links: [
      { to: '/account', label: 'Channels' },
      { to: '/account/invites', label: 'Refer a Friend' },
      { to: '/account/coupons', label: 'Coupons' },
      { to: '/account/favourites', label: 'Favourites' },
      { to: '/account/connected-accounts', label: 'Connected Accounts' },
      { to: '/account/licenses', label: 'Licenses' },
      { to: '/account/orders', label: 'Orders' },
      { to: '/account/billing', label: 'Billing' },
      { to: '/account/communication', label: 'Communication Preferences' },
      { to: '/account/profile', label: 'My Profile' },
    ],
  };

  static styles = {
    container: style({
      position: 'relative',
    }),
    list: style(
      mediaMobileOnly({
        display: 'none',
      }),
      mediaTablet({
        ...horizontal,
        ...wrap,
        margin: 0,
        padding: px(20),
      }),
    ),
    item: style({
      display: 'inline-flex',
      margin: '0 20px 0 0',
    }),
    link: style({
      display: 'inline-block',
      padding: '4px 0',
      color: colorSubtle.toString(),
      borderBottom: '2px solid transparent',
      transition: `border-color ${transitionQuickEase}`,
      $nest: {
        ...resetAnchorStyles(colorSubtle.toString()),
      },
    }),
    linkActive: style({
      color: important(colorContrast.toString()),
      fontWeight: 500,
    }),
    select: style(
      mediaMobileOnly({
        padding: '0 20px 0 12px',
        lineHeight: px(50),
        height: px(48),
        width: percent(100),
        background: colorSlate.darken(0.05).toString(),
        border: 0,
        borderRadius: 0,
        margin: 0,
        color: colorWhite.toString(),
        fontSize: px(18),
        fontFamily: fontHeading,
        borderBottom: `1px solid ${colorBackground.toString()}`,
      }),
      mediaTablet({
        display: 'none',
      }),
    ),
    arrow: style(
      mediaMobileOnly({
        position: important('absolute'),
        top: px(20),
        right: px(20),
        transform: 'rotate(90deg)',
        stroke: colorWhite.toString(),
      }),
      mediaTablet({
        display: 'none',
      }),
    ),
  };
}
